import { authService } from '../auth/authService.js';

class NaverBlogService {
    constructor() {
        this.db = null;
        this.init();
    }

    init() {
        if (typeof firebase !== 'undefined' && typeof firebase.firestore === 'function' && firebase.apps.length) {
            this.db = firebase.firestore();
        }
    }

    _withTimeout(promise, ms = 2500) {
        return Promise.race([
            promise,
            new Promise((_, reject) => setTimeout(() => reject(new Error("Firebase Operation Timeout")), ms))
        ]);
    }

    /**
     * Get Naver Blog configuration from Firestore, falling back to LocalStorage
     */
    async getConfig() {
        const localData = this._getLocalConfig();
        
        // Dynamic re-initialization check if firebase became available later
        if (!this.db) {
            this.init();
        }

        if (!this.db || localStorage.getItem('localMode') === 'true') {
            return localData;
        }

        try {
            const user = authService.auth?.currentUser;
            if (!user) {
                return localData;
            }

            const doc = await this._withTimeout(this.db.collection('userConfigs').doc(user.uid).get(), 2500);
            if (doc.exists && doc.data()?.naverBlog) {
                const firestoreConfig = doc.data().naverBlog;
                localStorage.setItem('auraDoc_naverBlogConfig', JSON.stringify(firestoreConfig));
                return firestoreConfig;
            }
            return localData;
        } catch (e) {
            console.warn("[NaverBlogService] Firestore read failed, falling back to localStorage.", e);
            return localData;
        }
    }

    /**
     * Save Naver Blog configuration to Firestore and LocalStorage
     */
    async saveConfig(config) {
        localStorage.setItem('auraDoc_naverBlogConfig', JSON.stringify(config));

        if (!this.db) {
            this.init();
        }

        if (!this.db || localStorage.getItem('localMode') === 'true') {
            return;
        }

        try {
            const user = authService.auth?.currentUser;
            if (!user) return;

            await this._withTimeout(
                this.db.collection('userConfigs').doc(user.uid).set({
                    naverBlog: config,
                    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
                }, { merge: true }),
                2500
            );
            console.log("[NaverBlogService] Naver Blog Config saved to Firestore successfully.");
        } catch (e) {
            console.error("[NaverBlogService] Firestore write failed:", e);
        }
    }

    _getLocalConfig() {
        try {
            const saved = localStorage.getItem('auraDoc_naverBlogConfig');
            return saved ? JSON.parse(saved) : null;
        } catch (e) {
            return null;
        }
    }
}

export const naverBlogService = new NaverBlogService();
